import type { BifrostWeb } from '@seekrtech/bifrost-web'
import type { Result, UserInfo } from '../types'

export interface UserServiceMethods {
  getUserInfo: () => Promise<Result<UserInfo | null>>
  refreshToken: () => Promise<Result<UserInfo>>
  refreshServiceLevel: () => Promise<void>
}

export function createUserService(bifrost: BifrostWeb): UserServiceMethods {
  return bifrost
    .createProxyBuilder<UserServiceMethods>('UserService')
    .withDefaultOptions({ timeout: 30_000 })
    .build()
}
